// extracted by mini-css-extract-plugin
export default {"container":"backButton_container__Fi92s","text":"backButton_text__wSHRM"};